import { connect } from 'react-redux';
import NewCardSuccess from './NewCardSuccess';

function mapStateToProps({ config }) {
  return {
    consumerHost: config.consumerHost,
  };
}

export default connect(mapStateToProps)(NewCardSuccess);
